import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=7be3b23b&scoped=true&"
import script from "./Send.vue?vue&type=script&lang=js&"
export * from "./Send.vue?vue&type=script&lang=js&"
import style0 from "./Send.vue?vue&type=style&index=0&id=7be3b23b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3b23b",
  null
  
)

export default component.exports